// at least 9 digits, + allowed at the begging and - allowed in the middle
export const getPhoneRegex = () => {
  return /^(?:\+)?(?!-)(?=(?:\D*\d){9})[0-9\s-]*(?<!-)$/;
}